import { useFacilityDetails } from 'apis/getFacilityDetails';
import React, { createContext, ReactNode } from 'react';
import { useParams } from 'react-router-dom';


// Define the context type
type IContextType = {
    project_id: string | undefined;
    projectName: string;
    asset_id: string | undefined;
    assetName: string;
}

// Define the props for the provider
type IProviderProps ={
    children: ReactNode;
}

// Create the context with an initial value of null
const FacilityDetailsContext = createContext<IContextType>({} as IContextType);

// Provider component
const FacilityDetailsProvider: React.FC<IProviderProps> = ({ children }) => {
    const { project_id, asset_id } = useParams<{ project_id?: string; asset_id?: string }>();

    const {data: projectData, isFetching: isProjectFetching} = useFacilityDetails({id: project_id, config: { staleTime: 1000 }});
    const {data: assetData, isFetching: isAssetFetching} = useFacilityDetails({id: asset_id, config: { staleTime: 1000 }});


    const data: IContextType = {
        project_id: project_id,
        projectName: projectData?.name || "",
        asset_id: asset_id,
        assetName: assetData?.name || "",
    }



    return (
        <FacilityDetailsContext.Provider value={data}>
            {children}
        </FacilityDetailsContext.Provider>
    );
}

// Optional: custom hook for consuming the context
export { FacilityDetailsProvider };
export default FacilityDetailsContext;